import { render } from "./LeftMenuContent.vue?vue&type=template&id=62839fb9"
import script from "./LeftMenuContent.vue?vue&type=script&lang=js"
export * from "./LeftMenuContent.vue?vue&type=script&lang=js"

import "./LeftMenuContent.vue?vue&type=style&index=0&id=62839fb9&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__